
import { defineComponent, PropType, computed } from 'vue'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'

export default defineComponent({
  props: {
    kamokuList: {
      type: Array as PropType<Kamoku[]>,
      required: true
    },
    selectedKamoku: {
      type: null,
      required: false,
      default: null
    }
  },

  emits: {
    selectedRow: (kamoku: Kamoku) => true
  },

  setup (props, { emit }) {
    const rowKey = computed(() => (item: Kamoku) => {
      switch (item.type) {
        case 'KamokuKubun':
          return `kbn-${item.kmkKbnCode}`
        case 'KanjouKamoku':
          return `knj-${item.knjKmkCode}`
        case 'HojoKamoku':
          return `hojo-${item.knjKmkCode}-${item.hojoCode}`
        default:
          throw Error('unkown kamoku type')
      }
    })
    const onClickTableRow = (kamoku: Kamoku) => {
      emit('selectedRow', kamoku)
    }

    const isSelected = (item: Kamoku): boolean => {
      const selected = props.selectedKamoku
      if (selected === null) {
        return false
      }
      return selected.kmkKbnCode === item.kmkKbnCode &&
        selected.knjKmkCode === item.knjKmkCode &&
        selected.hojoCode === item.hojoCode
    }

    return {
      rowKey,
      onClickTableRow,
      isSelected
    }
  }
})
